import { components } from 'react-select';
import { Icon } from '@usitsdasdesign/dds-react';
const { getShiftTimings } = require("services/demand.service");
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { formatHours } from 'lib/util';
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);


export const shiftColors = {
    'Morning': 'bg-yellow-800 !text-black',
    'Afternoon': 'bg-orange-100 !text-black',
    'Evening': 'bg-orange-400 !text-black',
    'Night': 'bg-blue-800 !text-white',
    'default': 'bg-gray-200',
    'Regular': 'bg-[#86cf74]',
    'General': 'bg-white !text-black',
    holiday: 'bg-green-100 !text-black',
    weekOff: 'bg-gray-100 !text-black',
};

export const shiftIcons = {
    'Morning': '/images/morning-icon.svg',
    'Afternoon': '/images/afternoon-icon.svg',
    'Evening': '/images/afternoon-icon.svg',
    'Night': '/images/night-icon.svg',
    holiday: '/images/holiday-icon.svg',
    weekOff: '',
    'default': '',
};

export const shiftIconOption = {
    'Morning': '/images/morning-icon.svg',
    'Afternoon': '/images/afternoon-icon.svg',
    'Evening': '/images/afternoon-icon.svg',
    'Night': '/images/night-icon-b.svg',
    holiday: '/images/holiday-icon.svg',
    weekOff: '',
    'default': '',
};

export const loadShiftTimingOptions = async (search, setOffset, setHasMore) => {
    const limit = 10;
    let prevOffset;
    setOffset((prev) => {
        prevOffset = prev;
        return search?.length ? 0 : prev + limit;
    });
    const response = await getShiftTimings({
        offset: prevOffset,
        limit,
        search
    })
    if (response?.status && response?.entity) {
        const options = response.entity.rows.map((item) => ({
            ...item,
            label: item.shiftTiming,
            value: item.id,
            color: shiftColors[item.shiftType] || colors.default,
            icon: shiftIcons[item.shiftType] || icon.default,
            id: item.id,
        }));
        const hasMoreOptions = response.entity.count > prevOffset + limit;

        setHasMore(hasMoreOptions);
        return {
            options,
            hasMore: search?.length ? false : hasMoreOptions
        };
    }
    return {
        options: [],
        hasMore: false
    };
}

export const getDemandShiftTimingsPayload = (shiftTimings = {}) => {
    const shiftDates = Object.keys(shiftTimings);
    const demandShiftTimings = [];
    shiftDates.forEach((date) => {
        const shiftDetails = shiftTimings[date];
        demandShiftTimings.push({
            shiftDate: date,
            shiftTimingId: shiftDetails?.value ?? null,
            onCallSupport: shiftDetails?.onCallSupport?.isOnCallSupport ?? false,
            onCallSupportShiftTimingId: shiftDetails?.onCallSupport?.onCallSupportShiftTime?.value ?? null,
            onCallSupportType: shiftDetails?.onCallSupport?.callSupportType ?? null
        })
    });
    return demandShiftTimings;
}

export const getAllocationShiftTimingsPayload = getDemandShiftTimingsPayload;

export const getProposalShiftTimingsPayload = getDemandShiftTimingsPayload;

export const getSoftBlockShiftTimingsPayload = getDemandShiftTimingsPayload;
export const getShiftAllowancePayload = (shiftTimings = {}) => {    
    const shiftDates = Object.keys(shiftTimings);
    const demandShiftTimings = [];
    shiftDates.forEach((date) => {
        const shiftDetails = shiftTimings[date];        
        demandShiftTimings.push({
            shiftDate: date,
            shiftStatus: shiftDetails?.shiftStatus || 'pending',
            onCallSupportStatus: shiftDetails?.onCallSupportStatus || 'pending',
            shiftTimingId: shiftDetails?.value ?? null,
            onCallSupport: shiftDetails?.onCallSupport?.isOnCallSupport ?? false,
            onCallSupportShiftTimingId: shiftDetails?.onCallSupport?.onCallSupportShiftTime?.value ?? null,
            onCallSupportType: shiftDetails?.onCallSupport?.callSupportType ?? null
        })
    });    
    return demandShiftTimings;
}

export const getDemandShiftTimingFormData = (demandShiftTimings = []) => {
    const shiftData = {};
    demandShiftTimings.forEach((item) => {
        const shiftDate = item.shiftDate;
        const shiftTimingDetails = item.shiftTiming;
        shiftData[shiftDate] = shiftTimingDetails || item?.onCallSupportShiftTiming ? {
            ...(shiftTimingDetails ?? {}),
            label: shiftTimingDetails?.shiftTiming ?? null,
            value: shiftTimingDetails?.id ?? null,
            onCallSupport:{
                isOnCallSupport: item.onCallSupport ?? false,
                onCallSupportShiftTime: item.onCallSupportShiftTimingId ? {
                    ...item.onCallSupportShiftTiming,
                    label: item.onCallSupportShiftTiming?.shiftTiming,
                    value: item.onCallSupportShiftTimingId
                } : null,
                callSupportType: item.onCallSupportType || null
            }
        } : null;
    });
    return shiftData;
};

export const getShiftAllowanceShiftTimingFormData = (demandShiftTimings = []) => {
    const shiftData = {};
    demandShiftTimings.forEach((item) => {
        const shiftDate = item.shiftDate;
        const shiftTimingDetails = item.shiftTiming;  
        const hours = item?.allocation?.resource?.swiftTimesheets?.[0]?.actualHours ?? 0;
        shiftData[shiftDate] = shiftTimingDetails || item?.onCallSupportShiftTiming ? {
            ...(shiftTimingDetails ?? {}),
            allocationId: item.allocationId,
            shiftStatus: item.shiftStatus,
            onCallSupportStatus: item.onCallSupportStatus,
            scheduledHours: item.scheduledHours,
            //actualHours: formatHours(item?.allocation?.resource?.swiftTimesheets?.[0]?.actualHours ?? 0),
            actualHours:  typeof hours === 'string' && (hours.includes('(H)') || hours.includes('(L)')) ? hours : item?.isHoliday ? `${hours}(H)`: item?.isLeave ? `${hours}(L)` : formatHours(hours),
            isHoliday: item.isHoliday,
            isLeave: item.isLeave,
            leaveName: item.leaveName,
            label: shiftTimingDetails?.shiftTiming ?? null,
            value: shiftTimingDetails?.id ?? null,
            onCallSupport:{
                isOnCallSupport: item.onCallSupport ?? false,
                onCallSupportShiftTime: item.onCallSupportShiftTimingId ? {
                    ...item.onCallSupportShiftTiming,
                    scheduledHours: item.scheduledHours,
                    actualHours: formatHours(item?.allocation?.resource?.swiftTimesheets?.[0]?.actualHours ?? 0),
                    label: item.onCallSupportShiftTiming?.shiftTiming,
                    value: item.onCallSupportShiftTimingId
                } : null,
                callSupportType: item.onCallSupportType || null
            }
        } : null;
    });
    return shiftData;
};

export const getAllocationShiftTimingFormData = getDemandShiftTimingFormData;

export const generateShiftTimings = ({ startDate, endDate, shiftData = {} }) => {
    let date = dayjs(startDate).clone();
    const newShiftData = {};
    while (date.isSameOrBefore(dayjs(endDate), 'day')) {
        const formattedDate = date.format('YYYY-MM-DD');
        newShiftData[formattedDate] = shiftData[formattedDate] || null;
        date = date.add(1, 'day');
    }
    return newShiftData;
};

export const validateMandatoryShiftTimings = ({ startDate, endDate, shiftTimings }) => {
    const formattedStartDate = dayjs(startDate);
    const formattedEndDate = dayjs(endDate);
    let date = formattedStartDate.clone();
    if (!shiftTimings || !formattedStartDate || !formattedEndDate) {
        return false;
    }
    while (date.isSameOrBefore(formattedEndDate, 'day')) {
        const dayOfWeek = date.day();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
            const formattedDate = date.format('YYYY-MM-DD');
            if (!shiftTimings[formattedDate]) {
                return false;
            }
        }
        date = date.add(1, 'day');
    }
    return true;

}

export const customShiftOption = (props) => {
    const { innerProps, innerRef, data, isFocused } = props;
    const shiftType = data?.shiftType || 'default';
    const icon = shiftIconOption[shiftType] || '';
    const typeFirstLetter = shiftType?.charAt(0) || '';

    return (
        <div
            ref={innerRef}
            {...innerProps}
            className={`px-2 py-3 cursor-pointer transition-all text-xs leading-none flex items-center gap-1 text-black hover:bg-green-900 hover:text-white ${isFocused ? 'option-focused' : ''}`}
        >
            {icon && <img src={icon} alt={`${shiftType} icon`} className="w-3 h-3" />}   <span className="font-semibold">{typeFirstLetter}</span>| {data.label}
        </div>
    );
};

export const CustomSingleValue = (props) => {
    const { data } = props;
    const shiftType = data?.shiftType || 'default';
    const icon = shiftIconOption[shiftType] || '';
    const typeFirstLetter = shiftType?.charAt(0) || '';

    return (
        <components.SingleValue {...props}>
            <div className="flex items-center gap-1 text-xs leading-none !text-black whitespace-nowrap">
                {icon && (
                    <img src={icon} alt={`${shiftType} icon`} className="w-3 h-3" />
                )}
                <span className="font-semibold">{typeFirstLetter}</span>| {data?.label}
            </div>
        </components.SingleValue>
    );
};

const CustomSingleOptionWithClear = (props) => {
    const { children, selectProps } = props;
    const selected = selectProps.value;
    const shiftType = selected?.shiftType;
    const shiftStyle = shiftType ? shiftColors[shiftType] : 'text-black';
    const icon = shiftIcons[shiftType] || '';
    const typeFirstLetter = shiftType?.charAt(0) || '';
    const handleClear = (e) => {
        e.stopPropagation();
        selectProps.onChange(null);
    };

    return (
        <components.MenuList {...props}>
            {selected && (
                <div className={`flex items-center justify-between m-2 px-2 py-1  ${shiftStyle}`}>
                    <div className={`flex items-center gap-1`}>
                        {icon && <img src={icon} alt="" className="w-2.5 h-2.5" />}
                        <span className='text-xs'>
                            <span className="font-semibold">{typeFirstLetter}</span> {selected?.label}
                        </span>
                    </div>
                    <span onClick={handleClear}
                        className='cursor-pointer'>
                        <Icon icon="close__l__stroke" className='w-3' color={selected?.shiftType === 'Night' ? 'white' : 'black'} />
                    </span>
                </div>
            )}
            <div className='border-t border-gray-200'>
                {children}
            </div>

        </components.MenuList>
    );
}

export default CustomSingleOptionWithClear;
